:host{display:flex;align-items:center;justify-content:space-between}.dot{display:inline-block;height:20px;width:20px;border-radius:50%;margin-bottom:5px}
/*# sourceMappingURL=sensor-color-option.component.css.map */
